import React, { useState } from "react";
import { BsEye, BsEyeFill, BsEyeSlashFill } from "react-icons/bs";

const PasswordInputField = ({ label, placeholder, value, onChange, error }) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="d-flex flex-column gap-2 mb-2 ">
      <span className="text-black fs-normal">{label}</span>
      <div className="position-relative">
        <input className="w-100 bg-grey2 border-0 outline-0 px-2 py-2 rounded fs-md text-black fw-medium" value={value} type={showPassword ? "text" : "password"} onChange={onChange} placeholder={placeholder ?? "Enter text..."} />
        <button type="button" className="position-absolute top-50 end-0 translate-middle-y bg-transparent border-0 px-3" onClick={togglePasswordVisibility}>
          {showPassword ? <BsEyeSlashFill color="gray" /> : <BsEyeFill color="gray" />}
        </button>
      </div>
      <span className="text-danger fs-sm">{error || ""}</span>
    </div>
  );
};

export default PasswordInputField;
